import "../App.css";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();

  return (
    <div>
      {/* Desktop Navbar */}
      <div className="themeBg lg:grid hidden h-18 grid-cols-11 z-100 w-full fixed top-0 text-zinc-300">
        <div></div>

        <Link
          to="/"
          className={`col-span-1 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/" ? "border-b-4 border-blue-600/70" : ""
          }`}
        >
          Omnicraft Studios
        </Link>

        <div className="col-span-5"></div>

        <Link
          to="/about"
          className={`col-span-1 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/about"
              ? "border-b-4 border-blue-600/70"
              : ""
          }`}
        >
          About
        </Link>

        <Link
          to="/application"
          className={`col-span-1 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/application" ||
            location.pathname === "/new-member-application" ||
            location.pathname === "/former-member-application"
              ? "border-b-4 border-blue-600/70"
              : ""
          }`}
        >
          Apply
        </Link>

        <a
          className="col-span-1 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center"
          target="_blank"
          rel="noopener noreferrer"
          href="http://mc.omnicraftstudios.com:8123"
        >
          <div className="lg:mx-[10%] mx-[5%]">Realtime Worldmap</div>
        </a>

        <a
          className="col-span-1 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center"
          target="_blank"
          rel="noopener noreferrer"
          href="https://discord.gg/uwcRznrJsp"
        >
          <div className="lg:mx-[10%] mx-[5%]">Discord Server</div>
        </a>
      </div>

      {/* Mobile Navbar */}
      <div className="themeBg lg:hidden grid h-18 grid-cols-10 z-100 w-full fixed top-0 text-zinc-300">
        <Link
          to="/"
          className={`col-span-5 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/" ? "border-b-4 border-blue-600/70" : ""
          }`}
        >
          Omnicraft
        </Link>

        <Link
          to="/application"
          className={`col-span-2 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/application" ||
            location.pathname === "/new-member-application" ||
            location.pathname === "/former-member-application"
              ? "border-b-4 border-blue-600/70"
              : ""
          }`}
        >
          Apply
        </Link>

        <Link
          to="/about"
          className={`col-span-2 link text-center text text-xl font-bold hover:text-zinc-300 hover:bg-blue-600/70 h-full flex items-center justify-center ${
            location.pathname === "/about"
              ? "border-b-4 border-blue-600/70"
              : ""
          }`}
        >
          About
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
